import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Job from '../views/pages/Job.vue'
import Steps from '../views/pages/Steps.vue'
import CampusRecruiting from '../views/pages/CampusRecruiting.vue'
import Contact from '../views/pages/Contact.vue'
import Company from '../views/pages/Company.vue'
import FAQ from '../views/pages/FAQ.vue'
import JobDetail from '../views/pages/JobDetail.vue'
import News from '../views/pages/News.vue'
import Experience from '../views/pages/Experience.vue'
import Feature from '../views/pages/Feature.vue'
import Doing from '../views/pages/Doing.vue'


Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
    children: [
      {
        path: '/Job',// 申请职位
        name: 'Job',
        component: Job,
        children: [
          {
            path: '/Job/JobDetail',// 工作详情
            name: 'JobDetail',
            component: JobDetail
          }
        ]
      },
      {
        path: '/Steps',// 应聘流程
        name: 'Steps',
        component: Steps
      },{
        path: '/CampusRecruiting',// 校园招聘
        name: 'CampusRecruiting',
        component: CampusRecruiting
      },{
        path: '/Contact',// 联系我们
        name: 'Contact',
        component: Contact
      },{
        path: '/Company',// 公司发展
        name: 'Company',
        component: Company
      },
      {
        path: '/FAQ',// 常见问题
        name: 'FAQ',
        component: FAQ
      }, {
        path: '/News/:id',// 招聘动态
        name: 'News',
        component: News
      }, {
        path: '/Experience',// 工作体验
        name: 'Experience',
        component: Experience
      }, {
        path: '/Feature',// 特色机制
        name: 'Feature',
        component: Feature
      }, {
        path: '/Doing/:id',// 我们做的事
        name: 'Doing',
        component: Doing
      }
    ]
  },

  // {
  //   path: '/about',
  //   name: 'About',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  routes
})

export default router
